import { registerTheme } from '../../theme';
import { DEFAULT_COLUMN_THEME } from '../column/theme';

registerTheme('stackedColumn', DEFAULT_COLUMN_THEME);
